<template>
  <div>
    <p class="title">{{$t('APP-FIELD-0148')}}</p>

    <div class="img_info_box">
      <section>
        <div class="img_box">
          <img src="@/assets/html5/img_doc_id@2x.png">
        </div>
        <div class="content-box">
          <p>{{ cardNum }} {{$t('APP-FIELD-0149')}}</p>
          <p class="cards-text" @click="validCardsShow = true">{{$t('APP-FIELD-0150')}}</p>
        </div>
      </section>

      <section v-if="!agencyBanking" >
        <div class="img_box">
          <img src="@/assets/html5/img_doc_signature@2x.png">
        </div>
        <div class="content-box">
          <p>{{$t('APP-FIELD-0151')}}</p>
        </div>
      </section>

      <section v-if="thirdShow">
        <div class="img_box">
          <img src="@/assets/html5/img_doc_buzdoc@2x.png">
        </div>
        <div class="content-box">
          <p v-if="step !== '1-3'">{{$t('APP-FIELD-0152')}}</p>
          <p v-if="step === '1-3'">{{$t('APP-FIELD-0194')}}</p>
          <span v-if="step === '1-3'">{{$t('APP-FIELD-0206')}}</span>
        </div>
      </section>
    </div>

    <p class="tips">{{$t('APP-FIELD-0153')}}</p>


    <valid-cards v-model="validCardsShow"></valid-cards>
  </div>
</template>

<script>
  import ValidCards from "./ValidCards";

  export default {
  name: 'PrepareDocuments',
  props: {
    'cardNum': {
      type: Number,
      default: 1,
    },

    agencyBanking: {
      type: Boolean,
      default: false
    },

    thirdShow: {
      type: Boolean,
      default: false
    },

    step: {
      type: String,
      default: '',
    },
  },
  components: {
    ValidCards
  },

  data() {
    return {
      validCardsShow: false
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .img_info_box{
    margin: 56px 0;
    .img_box{
      width: 20%;
      text-align: center;
      vertical-align: middle;
      display: inline-block;
      img{
        width: 150px;
      }
    }
    .content-box{
      display: inline-block;
      vertical-align: middle;
      p{
        font-family: Nunito-Bold;
        font-size: 16px;
        color: #2C2C2C;
        letter-spacing: 0.11px;
      }
      .cards-text {
        font-family: Nunito-Regular;
        font-size: 16px;
        color: #0072D7;
        letter-spacing: 0.14px;
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }

  .tips {
    font-family: Nunito-Regular;
    font-size: 16px;
    color: #2C405A;
    letter-spacing: 0.08px;
    line-height: 24px;
    margin-bottom: 65px;
  }
</style>
